import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { DashboardAdmin } from "../pages/adminPages/DashboardAdmin";
import { Tables } from "../pages/Tables/Tables";
import LoginForm from "../pages/login/LoginForm";
import DoctorProfile from "../pages/doctorPages/profile/DoctorProfile";
import ProfileChangeReview from "../pages/adminPages/ProfileChangeReview/ProfileChangeReview";
import PendingProfileChanges from "../pages/adminPages/PendingProfileChanges/PendingProfileChanges";
import DoctorsRegistrations from "../pages/adminPages/DoctorsRegistrations";
import DoctorsRequests from "../pages/adminPages/DoctorsRequests";
import SendMessage from "../pages/doctorPages/chat/components/SendMessage/SendMessage";
import Unauthorized from "../pages/unauthorized/Unauthorized";
import NoMatch from "../pages/unauthorized/NoMatch";
import Patients from "../pages/doctorPages/chat/patientsList/Patients";
import UserDetailsPage from "../pages/doctorPages/chat/components/PatientDetailsPage/UserDetailsPage";
import { AllDoctorsTable } from "../pages/adminPages/AllDoctorsTable/AllDoctorsTable";
import { AllPatientsTable } from "../pages/adminPages/AllPatientsTable/AllPatientsTable";
import { PendingRequestsTable } from "../pages/adminPages/PendingRequestsTable/PendingRequestsTable";
import Home from "../Home";
import RequestPasswordReset from "../pages/reset-password/RequestPasswordReset";
import ResetPassword from "../pages/reset-password/ResetPassword";
import PrivacyPage from "../pages/privacy/PrivacyPage";

import DocumentsPage from "../pages/doctorPages/chat/components/DocumentsPage/DocumentsPage";

import BloodTestsPage from "../pages/doctorPages/chat/components/BloodTestsPage/BloodTestsPage";

const RoutesPath = () => {
  // todo can navigate is does have authority. this is blocked at the backend, manage at the frontend as well
  // todo make nested route for patient
  // todo: what if the doctor navigate directly to "patients/send_message" without selecting a patient?
  return (
    <Fragment>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="medicalStaff" element={<Tables />} />
          <Route
            path="doctors_registrations"
            element={<DoctorsRegistrations />}
          />
          <Route path="doctors_requests" element={<DoctorsRequests />} />
           <Route path="doctor_profile" element={<DoctorProfile />} />
          {/* <Route path="exercises" element={<PatientsAggregatedData />} /> */}
          <Route path="patients" element={<Patients />}>
            <Route path="send_message" element={<SendMessage />} />
            <Route path="user_details" element={<UserDetailsPage />} />
            <Route path="blood_tests" element={<BloodTestsPage />} />
            <Route path="user_documents" element={<DocumentsPage />} />
          </Route>
          

          {/*ADMIN ROUTES*/}
          <Route path="all_doctors" element={<AllDoctorsTable />} />
          <Route path="all_patients" element={<AllPatientsTable />} />
          <Route
            path="pending_doctor_requests"
            element={<PendingRequestsTable />}
          />

          <Route
            path="pending_profile_changes"
            element={<PendingProfileChanges />}
          />
          <Route
            path="profile-change-review"
            element={<ProfileChangeReview />}
          />

          <Route path="dashboard_admin" element={<DashboardAdmin />} />
          <Route path="unauthorized" element={<Unauthorized />} />
          <Route
            path="request_password_reset"
            element={<RequestPasswordReset />}
          />
          <Route
              path="privacy_policy"
              element={<PrivacyPage />}
          />
          <Route path="reset_password" element={<ResetPassword />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Router>
    </Fragment>
);
};

export default RoutesPath;
